module.exports = __webpack_public_path__ + "SY.png?200f38a2533b0377b6688b7d34d956b8";